import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import authenticate from "../../utils/Authenticate";
import UserContext from "../../contexts/UserContext";
import { FaMapMarkerAlt, FaPhoneAlt, FaTruck, FaComment } from 'react-icons/fa';
import axios from 'axios';
import { formatMoney } from '../../utils/currency';

const Requests = () => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [showSupplyCard, setShowSupplyCard] = useState(false);
  const [showDispatchDetails, setShowDispatchDetails] = useState(false);
  const [currentSupplier, setCurrentSupplier] = useState(null);
  const { request, index } = location.state || {};
  const [bills, setBills] = useState({});



  useEffect(() => {
      request.items.forEach(item => {
        const supplierName = item?.item?.supplier?.name || item?.supplier?.id?.name || item?.zoneSupplier?.id?.name;
        const key = `${request._id}_${supplierName}`;
        if (supplierName && request._id && !bills[key]) {
          getBillsForRequests(request._id, supplierName);
        }
      });
  }, [request]);

  const getBillsForRequests = async (requestId, supplierName) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URI}/api/bill/get?requestId=${requestId}&supplierName=${supplierName}`,
      { withCredentials: true }
    );

    const key = `${requestId}_${supplierName}`;

    if (response.data.success) {
      setBills(prev => ({
        ...prev,
        [key]: response.data.data
      }));
    } else {
      setBills(prev => ({
        ...prev,
        [key]: null
      }));
    }
  } catch (err) {
    console.error(err);
  }
};


  const getStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-500';
      case 'approved':
        return 'bg-green-500';
      case 'supplyapproved':
        return 'bg-teal-500';
      case 'rejected':
        return 'bg-red-500';
      case 'dispatched':
        return 'bg-green-500';
      case 'Items Received':
        return 'bg-green-500';
      case 'received':
        return 'bg-green-500';
      default:
        return 'bg-orange-500';
    }
  };

  const getItemStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-500';
      case 'approved':
        return 'bg-green-500';
      case 'supplyapproved':
        return 'bg-teal-500';
      case 'supplyrequested':
        return 'bg-teal-700';
      case 'rejected':
        return 'bg-red-500';
      case 'dispatched':
        return 'bg-blue-500';
      case 'received':
        return 'bg-green-500';
      case 'partiallyReceived':
          return 'bg-cyan-500';
      default:
        return 'bg-orange-500';
    }
  };

  const showSupplierCard = (supplier) => {
    setCurrentSupplier(supplier);
    setShowSupplyCard(true);
    document.body.style.overflow = 'hidden'; // Disable scrolling
  };

  const showDispatchCard = (supplier) => {
    setCurrentSupplier(supplier);
    setShowDispatchDetails(true);
    document.body.style.overflow = 'hidden'; // Disable scrolling
  };

  const closeModals = () => {
    setShowSupplyCard(false);
    setShowDispatchDetails(false);
    document.body.style.overflow = 'auto'; // Enable scrolling
  };

  const SupplierCard = () => (
    <>
      <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow dark:bg-gray-700 max-w-2xl w-full mx-3">
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
              Supplier Details
            </h3>
            <button onClick={closeModals} className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
              <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className="p-4 md:p-5 space-y-4">
            <p className="text-base leading-relaxed text-gray-900 dark:text-gray-100">
              Supplier: <span className="font-semibold text-gray-900 dark:text-gray-100">{currentSupplier?.name || currentSupplier?.company}</span>
            </p>
            <p className="text-base leading-relaxed text-gray-900 dark:text-gray-100">
              Supplier Contact: <span className="font-semibold text-gray-900 dark:text-gray-100">{currentSupplier?.contact}</span>
            </p>
          </div>
          <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
            <button onClick={closeModals} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">OK</button>
            <button onClick={closeModals} className="py-2.5 px-5 ml-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">Close</button>
          </div>
        </div>
      </div>
    </>
  );

  const DispatchCard = () => (
    <>
      <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow dark:bg-gray-700 max-w-2xl w-full mx-3">
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
              Dispatch Details
            </h3>
            <button onClick={closeModals} className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
              <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className="p-4 md:p-5 space-y-4">
            <div className="rounded-lg p-4">
              <p className="text-base leading-relaxed text-gray-900 dark:text-gray-100">
                Supplier: {currentSupplier?.id?.name || currentSupplier?.id?.company}
              </p>
              <p className="text-base leading-relaxed text-gray-900 dark:text-gray-100">
                Supplier Contact: {currentSupplier?.id?.contact}
              </p>
              <div className="text-gray-500 text-md flex items-center mt-2">
                <FaMapMarkerAlt className="mr-2 text-md text-yellow-400" />
                <span className="font-semibold text-sm">Address:&nbsp;</span> {currentSupplier?.dispatch?.address}
              </div>
              <div className="text-gray-500 text-md flex items-center mt-2">
                <FaPhoneAlt className="mr-2 text-md text-yellow-400" />
                <span className="font-semibold text-sm">Contact:&nbsp;</span> {currentSupplier?.dispatch?.contact}
              </div>
              <div className="text-gray-500 text-md flex items-center mt-2">
                <FaTruck className="mr-2 text-md text-yellow-400" />
                <span className="font-semibold text-sm">Vehicle No:&nbsp;</span> {currentSupplier?.dispatch?.vehicleNo}
              </div>
              <div className="text-gray-500 text-md flex items-center mt-2">
                <FaComment className="mr-2 text-md text-yellow-400" />
                <span className="font-semibold text-sm">Comments:&nbsp;</span> {currentSupplier?.dispatch?.comments}
              </div>
            </div>
          </div>
          <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
            <button onClick={closeModals} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">OK</button>
            <button onClick={closeModals} className="py-2.5 px-5 ml-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">Close</button>
          </div>
        </div>
      </div>
    </>
  );

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    }
    startup();
  }, [user, setUser, navigate]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: '2-digit', year: 'numeric', weekday: 'short' };
    return date.toLocaleDateString('en-GB', options);
  };

  return (
    <>
      {user ? (
        <>
          <div className="bg-lime-900 flex items-center justify-between w-full px-4 text-white py-4 fixed z-10">
            <button
              className="flex items-center space-x-2"
              onClick={() => navigate("/zc/home")}
            >
              <span className="text-xl md:text-base">←</span>
            </button>
            {request.menu ? (
               
              <div className="flex-grow">
                <p className="text-sm text-gray-300 flex-grow text-center">
                  REQ #00{index + 1}
                     
                </p>
                <h4 className="py-2 text-lg md:text-xl font-semibold flex-grow text-center">
                  {request.menu.name}
                </h4>
              </div>
            ) : (
              <h4 className="py-2 text-lg md:text-xl font-semibold text-center flex-grow">
                REQ #00{index + 1}
                 
              </h4>
            )}
            {/* {request.menu ? console.log(request.menu) : console.log("no menu")} */}
          </div>

          <div className="px-3 my-5 pt-[90px]">
            <div
              key={request.index}
              className="bg-white rounded-xl border-gray-200 border shadow-md overflow-hidden w-full lg:w-full"
            >
              <div className="p-4">
                <div className="flex justify-between items-center mt-2 relative">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/zc/home/show-bills", {
                        state: {
                          viewRquestId: `REQ #00${index + 1}`,
                          requestId: request._id,
                          zoneId: request.zone?._id || request.zone,
                        },
                      });
                    }}
                    className="text-sm text-blue-600 underline"
                  >
                    Show Bill
                  </button>
                  
                  <div className="text-sm leading-tight font-medium text-black">
                    <span
                      className={`px-2 py-1 rounded ${getStatusColor(
                        request.status
                      )} text-white`}
                    >
                      {request.status}
                    </span>
                  </div>
                  <div className="text-gray-500 text-sm flex justify-center space-x-2">
                    <span>{formatDate(request.createdAt)}</span>
                    <span>
                      {new Date(request.createdAt).getHours()}:
                      {new Date(request.createdAt).getMinutes()}
                    </span>
                  </div>
                </div>

                <div className="mt-4">
                  {request.items.map((item, index) => (
                    <div key={index} className={`space-y-2 relative mb-2`}>
                      <div className="flex flex-col sm:flex-row justify-between items-start sm:space-y-0 relative">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                          <div className="flex flex-row justify-between sm:flex-grow sm:items-center my-2">
                            <div className="flex-grow">
                              <h3 className="text-sm text-fmb font-semibold">
                                {item.item.name}
                              </h3>
                              <p className="text-sm text-gray-600">
                                {item.item.category}
                              </p>
                              {typeof item.quantityReceived === "number" ? (
                                <>
                                  <p className="text-sm text-gray-400">
                                    Requested Quantity:{" "}
                                    <strong>
                                      {parseFloat(item.quantity).toFixed(2)}{" "}
                                      <span>{item.item.unit}</span>
                                    </strong>
                                  </p>
                                  <p className="text-sm text-green-600">
                                    Received Quantity:{" "}
                                    <strong>
                                      {parseFloat(item.quantityReceived).toFixed(2)}{" "}
                                      <span>{item.item.unit}</span>
                                    </strong>
                                  </p>
                                </>
                              ) : (
                                <p className="text-sm text-gray-400">
                                  Requested Quantity: {parseFloat(item.quantity).toFixed(2)}{" "}
                                  <span>{item.item.unit}</span>
                                </p>
                              )}
                              <p className="text-xs text-gray-600">
                                {item?.item?.basePrice
                                  ? formatMoney(user, item?.item?.basePrice)
                                  : null}
                              </p>
                            </div>
                            <div>
                              {(() => {
                                const supplierName =
                                  item?.item?.supplier?.name ||
                                  item?.supplier?.id?.name ||
                                  item?.zoneSupplier?.id?.name;

                                const billKey = `${request._id}_${supplierName}`;
                                const billData = bills[billKey];

                                if (billData) {
                                  return (
                                    <div className="">
                                      <a href={billData.file} target="_blank">
                                        <button className="bg-fmb text-white py-2 px-3 rounded text-sm font-normal hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50">
                                          View Bill
                                        </button>
                                      </a>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div className="text-xs text-gray-400">
                                      {/* No bill available */}
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                            <div className="flex items-center space-x-2 sm:ml-4">
                              <div
                                className={`text-xs text-white px-2 py-1 mx-2 font-semibold rounded ${getItemStatusColor(
                                  item.status
                                )}`}
                              >
                                {item.status}
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center">
                            {(item?.supplier?.id || item?.zoneSupplier?.id) &&
                            !(item?.status === "dispatched") ? (
                              <button
                                className="bg-fmb-light hover:bg-blue-700 text-white text-xs font-bold py-2 px-2 rounded"
                                onClick={() =>
                                  showSupplierCard(
                                    item?.supplier?.id
                                      ? item?.supplier?.id
                                      : item?.zoneSupplier?.id
                                  )
                                }
                              >
                                View Supplier
                              </button>
                            ) : null}
                          </div>
                          <div className="flex items-center">
                            {item.status === "dispatched" ? (
                              <button
                                className="bg-fmb-light hover:bg-blue-700 text-white text-xs font-bold py-2 px-2 rounded"
                                onClick={() =>
                                  showDispatchCard(
                                    item?.supplier || item?.zoneSupplier
                                  )
                                }
                              >
                                View Dispatch Details
                              </button>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      {index < request.items.length - 1 && (
                        <hr className="border-gray-300" />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {showSupplyCard && <SupplierCard />}
          {showDispatchDetails && <DispatchCard />}
        </>
      ) : (
        "Not authorized"
      )}
    </>
  );
};

export default Requests;
